import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Homepage "06 #1 in Brooklyn" section (Figma Wireframe_v2 1:3005): the four reasons, the
 *  25-mile same-day map with trucks running its routes, the delivery ticket and the legend.
 *  Static content; the motion is SMIL (animateMotion) in the map SVG, as in the design file,
 *  so it needs no script. Own component so its styles don't count toward the homepage's
 *  100kB component-style budget. */
@Component({
  selector: 'app-home-why',
  standalone: true,
  templateUrl: './home-why.component.html',
  styleUrl: './home-why.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeWhyComponent {
  readonly reasons = [
    { no: '01', title: "Brooklyn's #1 stockroom", text: "The widest and deepest inventory in town. You'll never need to hunt anywhere else.", meta: '20,000+ products in stock' },
    { no: '02', title: 'Local delivery today', text: 'We ship as fast as your job needs it: same day, up to 25 miles from Brooklyn.', meta: 'Same-day within 25 mi' },
    { no: '03', title: 'Materials fitted to you', text: 'In-house fabrication and custom material processing, made to order in our workshop.', meta: 'Arrives ready to build' },
    { no: '04', title: 'Priced for your profit', text: 'Account-based savings programs built for contractors and distributors.', meta: 'Save on every order' },
  ];
}
